import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'
import ImageUploaderDropZone from "../../../../common/image-uploader/dropzone.component.jsx"

const messages = defineMessages({
    "templates.sections.form.edit.content.image.size_15_label": {
        id: 'templates.sections.form.edit.content.image.size_15_label',
        defaultMessage: '15%',
    },
    "templates.sections.form.edit.content.image.size_25_label": {
        id: 'templates.sections.form.edit.content.image.size_25_label',
        defaultMessage: "25%",
    },
    "templates.sections.form.edit.content.image.size_50_label": {
        id: 'templates.sections.form.edit.content.image.size_50_label',
        defaultMessage: "50%",
    },
    "templates.sections.form.edit.content.image.size_75_label": {
        id: 'templates.sections.form.edit.content.image.size_75_label',
        defaultMessage: "75%",
    },
    "templates.sections.form.edit.content.image.size_100_label": {
        id: 'templates.sections.form.edit.content.image.size_100_label',
        defaultMessage: "100%",
    },
    "templates.sections.form.edit.content.image.alignment_left_label": {
        id:"templates.sections.form.edit.content.image.alignment_left_label",
        defaultMessage:"Left"
    },
    "templates.sections.form.edit.content.image.alignment_center_label": {
        id:"templates.sections.form.edit.content.image.alignment_center_label",
        defaultMessage:"Center"
    },
    "templates.sections.form.edit.content.image.alignment_right_label": {
        id:"templates.sections.form.edit.content.image.alignment_right_label",
        defaultMessage:"Right"
    },
    "templates.sections.form.edit.content.imagerow.linkUrl_placeholder": {
        id:"templates.sections.form.edit.content.imagerow.linkUrl_placeholder",
        defaultMessage:"https://www.tactiquote.com"
    },
})


class InputImage extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.imageContent || {}
        this.state = {
            onChange: this.props.onChange || function(){},
            imageCellIndex: this.props.imageCellIndex,
            images: content.image ? [content.image] : [],
            image: content.image || null,
            imageId: content.imageId || '',
            linkUrl: content.linkUrl || '',
            alignment: content.Alignment || 'center',
            size: content.size || '100',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
        this.onChangeGeneral = this.onChangeGeneral.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.imageContent || {}
        this.setState({
            image: content.image || null,
            imageId: content.imageId || '',
            alignment: content.alignment || 'center',
            size: content.size || '100',
            linkUrl: content.linkUrl || '',
        })

    }

    onChangeGeneral() {
        return this.state.onChange(this.state.imageCellIndex, {
            imageId: this.state.imageId,
            alignment: this.state.alignment,
            size: this.state.size,
            linkUrl: this.state.linkUrl,
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                images: images,
                image: images[0],
                imageId: images[0].id,
            }, this.onChangeGeneral)
        } else {
            this.setState({
                images: [],
                image: null,
                imageId: '',
            }, this.onChangeGeneral)
        }
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.onChangeGeneral)
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-12 col-form-label text-align-left "   htmlFor="title"><h4><strong>
                        <FormattedMessage
                            id="templates.sections.form.edit.content.imageRow.image_label"
                            defaultMessage="Image"
                        /> {this.state.imageCellIndex + 1}</strong></h4>
                    </label>
                    <div className="col-12">
                        <ImageUploaderDropZone
                            onUpdateImageList={this.handleImageChange}
                            maxFiles={1}
                            images={this.state.images}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-12 col-form-label text-align-left" htmlFor="size">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.imageRow.size_label"
                            defaultMessage="Size of the image (percentage of the available width)"
                        />
                    </label>
                    <div className="col-12">
                        <select
                            name="size"
                            value={this.state.size}
                            onChange={this.handleFormChange}
                            id="size"
                            className="form-control"
                        >
                            <option value="15">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_15_label"])}
                            </option>
                            <option value="25">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_25_label"])}
                            </option>
                            <option value="50">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_50_label"])}
                            </option>
                            <option value="75">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_75_label"])}
                            </option>
                            <option value="100">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.size_100_label"])}
                            </option>
                        </select>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-12 col-form-label text-align-left" htmlFor="linkUrl">
                        <FormattedMessage
                            id="templates.form.edit.content.imagerow.linkUrl_label"
                            defaultMessage="Link to website (optional)"
                        />
                    </label>
                    <div className="col-12">
                        <input
                            name="linkUrl"
                            value={this.state.linkUrl}
                            onChange={this.handleFormChange}
                            id="linkUrl"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage(messages['templates.sections.form.edit.content.imagerow.linkUrl_placeholder'])}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-12 col-form-label text-align-left" htmlFor="alignment">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.imageRow.alignment_label"
                            defaultMessage="Horizontal alignment of the image"
                        />
                    </label>
                    <div className="col-12">
                        <select
                            name="alignment"
                            value={this.state.alignment}
                            onChange={this.handleFormChange}
                            id="alignment"
                            className="form-control"
                        >
                            <option value="left">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_left_label"])}
                            </option>
                            <option value="center">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_center_label"])}
                            </option>
                            <option value="right">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.image.alignment_right_label"])}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(InputImage)


// WEBPACK FOOTER //
// ./src/template/sections/content/image-row/inputImage.component.jsx